import React from 'react';
import TaxonomyGuide from '../../components/admin/TaxonomyGuide';

/**
 * Systems & Sync Tab
 *
 * Reuses the comprehensive TaxonomyGuide component that explains:
 * - Product taxonomy system architecture
 * - 40+ canonical product types
 * - Shopify integration (metafields, tags, collections)
 * - Product recommendations and relations
 * - Pipeline execution and when to run each stage
 * - Troubleshooting common issues
 *
 * The TaxonomyGuide is a complete educational resource that covers:
 * - How the taxonomy system works
 * - How to influence each component (taxonomy, relations, collections, compatibility)
 * - What syncs to Shopify and how
 * - System memberships and compatibility matching
 * - Type affinity matrix for recommendations
 */
export default function SystemsTagsTab() {
  return <TaxonomyGuide />;
}
